var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { ratingApi } from 'apis/rating';
import { SurveySelect } from 'components/surveySelect';
import { isResponseWithData } from 'utils/apis/axios';
import { createAppModal } from 'utils/modal';
import styles from './selectSurveyModal.module.scss';
/** A component that displays a add survey modal. */
export const SelectSurveyModal = createAppModal({ type: 'settings:selectSurvey' }, ({ isOpen, modal, hide }) => {
    const { onSurveyLinked, currentSurvey, contactPoint, contactPointKind } = modal.arg;
    /** Handles closing the modal. */
    const handleClose = () => {
        hide === null || hide === void 0 ? void 0 : hide();
    };
    const [selectedSurvey, setSelectedSurvey] = useState(currentSurvey);
    const [linkRatingSettings] = ratingApi.useLazyLinkRatingSettingsQuery();
    const [unlinkRatingSettings] = ratingApi.useLazyUnlinkRatingSettingsQuery();
    const handleLinkRatingSettingsContactPoint = useCallback((selectedSurvey) => __awaiter(void 0, void 0, void 0, function* () {
        const unkinked = yield unlinkRatingSettings({
            rating_settings_id: selectedSurvey.id,
            contact_point: contactPoint,
            contact_point_kind: contactPointKind,
        }).unwrap();
        if (isResponseWithData(unkinked)) {
            const linked = yield linkRatingSettings({
                rating_settings_id: selectedSurvey.id,
                contact_point: contactPoint,
                contact_point_kind: contactPointKind,
            }).unwrap();
            if (isResponseWithData(linked)) {
                onSurveyLinked(linked.data);
                handleClose();
            }
        }
    }), [
        unlinkRatingSettings,
        contactPoint,
        contactPointKind,
        linkRatingSettings,
        onSurveyLinked,
        handleClose,
    ]);
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: _jsx(FlexBox, Object.assign({ gap: "200" }, { children: _jsxs(Text.Heading, { children: ["Connect a survey to ", contactPoint] }) })), onClose: handleClose }), _jsx(ModalBody, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "400" }, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3" }, { children: "CSAT survey" })), _jsx(SurveySelect, { onSelect: (survey) => {
                                    setSelectedSurvey(survey);
                                }, selectedSurvey: selectedSurvey })] })) })) }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmName: "Add", confirmOnClick: () => selectedSurvey &&
                    handleLinkRatingSettingsContactPoint(selectedSurvey), confirmProps: {
                    disabled: !selectedSurvey,
                } })] })));
});
